﻿$(document).on('ready', function(){
    var imageInterval;
    function refreshAndStop(timeout){
        clearInterval(imageInterval);
        setTimeout(function(){
            $(window).trigger('delayed-resize');
        }, timeout);
    }
    setTimeout(function(){
        imageInterval = setInterval(function(){
            if($('.grid-view-item__link').height() < ($('.grid-view-item__link').width() / 2) ){
                refreshAndStop(0);
            } else {
                refreshAndStop(1000);
            }
        }, 200);
    },1);
});

var validatePolish = {
    /**
     * Validation of NIP.
     * @param {*} nip
     * @returns {boolean}
     */
    nip(nip) {
        if (typeof nip !== 'string') {
            return false;
        }
        const nipWithoutDashes = nip.replace(/-/g, '');
        const reg = /^[0-9]{10}$/;
        if (reg.test(nipWithoutDashes) === false) {
            return false;
        }
        const dig = ('' + nipWithoutDashes).split('');
        const control = (6 * parseInt(dig[0], 10) +
            5 * parseInt(dig[1], 10) +
            7 * parseInt(dig[2], 10) +
            2 * parseInt(dig[3], 10) +
            3 * parseInt(dig[4], 10) +
            4 * parseInt(dig[5], 10) +
            5 * parseInt(dig[6], 10) +
            6 * parseInt(dig[7], 10) +
            7 * parseInt(dig[8], 10)) %
            11;
        if (parseInt(dig[9], 10) === control) {
            return true;
        }
        return false;
    }
};

$('.cart-nip #CartCustomNip').each(function(){
    var input = $(this);
    var errorNotice = $('.cart-nip-error');
    var checkoutBtn = $('input#cartCheckout');

    function inputError(){
        input.addClass('error');
        errorNotice.addClass('visible');
        checkoutBtn.attr('disabled', 'true');
    }
    function inputValid(){
        input.removeClass('error');
        errorNotice.removeClass('visible');
        checkoutBtn.removeAttr('disabled');
    }

    function checkInput(){
        if(input.val().length > 0){
            if(validatePolish.nip(input.val())){
                inputValid();
            } else {
                inputError();
            }
        } else {
            inputValid();
        }
    }

    $(document).on('ready', function(){
        checkInput();
        setTimeout(function(){
            // for late autofill
            checkInput();
        }, 1000);
        input.on('blur', function(){
            checkInput();
        });
        input.on('change input paste', function(){
            if(input.val().length == 10){
                checkInput();
            }
        })
    });
});

function mmSwitch(el) {
  var sid = el.getAttribute('data-section');
  var idx = el.getAttribute('data-idx');
  var left  = document.getElementById('mm-left-'  + sid);
  var right = document.getElementById('mm-right-' + sid);
  if (!left || !right) return;
  var cats = left.getElementsByClassName('mm-img-cat');
  for (var i = 0; i < cats.length; i++) {
    cats[i].style.background      = '';
    cats[i].style.borderLeftColor = '';
  }
  el.style.background      = '#f5f5f5';
  el.style.borderLeftColor = '#222';
  var panels = right.getElementsByClassName('mm-sub-panel');
  for (var j = 0; j < panels.length; j++) {
    panels[j].style.display = 'none';
  }
  var target = right.querySelector('.mm-sub-panel[data-idx="' + idx + '"]');
  if (target) target.style.display = 'block';
}

/* ============================================================
   RIVETS: custom formatters
   ============================================================ */
if (window.rivets) {
  rivets.formatters.compareGt = function(item) {
    return item && item.compare_at_price && item.compare_at_price > item.price;
  };
}

/* ============================================================
   MINI-CART: compare prices via /products/{handle}.js
   ============================================================ */
var _phoneoCapCache = window._phoneoCapCache || {};

function phoneoApplyComparePrices() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      if (!cart.items || !cart.items.length) return;
      var uniqueHandles = [];
      cart.items.forEach(function(item) {
        if (!_phoneoCapCache[item.handle] && uniqueHandles.indexOf(item.handle) < 0) {
          uniqueHandles.push(item.handle);
        }
      });
      var fetches = uniqueHandles.map(function(handle) {
        return fetch('/products/' + handle + '.js')
          .then(function(r) { return r.json(); })
          .then(function(p) {
            (p.variants || []).forEach(function(v) {
              _phoneoCapCache[v.id] = v.compare_at_price || 0;
            });
          });
      });
      Promise.all(fetches).then(function() {
        var rows = document.querySelectorAll('#cart-drawer .cart-item');
        var totalSavings = 0;
        cart.items.forEach(function(item, i) {
          var el = rows[i] && rows[i].querySelector('.cart-item__unit-old');
          if (!el) return;
          var cap = _phoneoCapCache[item.variant_id];
          var origLine = item.original_line_price || (item.price * item.quantity);
          var lineDiscount = origLine - item.line_price;
          var unitEl = rows[i] && rows[i].querySelector('.cart-item__unit-current');
          if (cap && cap > item.price) {
            el.textContent = (cap / 100).toFixed(2).replace('.', ',') + ' zł';
            el.style.display = 'block';
            totalSavings += (cap - item.price) * item.quantity;
          } else if (lineDiscount > 0) {
            var origUnit = Math.round(origLine / item.quantity);
            var discUnit = Math.round(item.line_price / item.quantity);
            el.textContent = (origUnit / 100).toFixed(2).replace('.', ',') + ' zł';
            el.style.display = 'block';
            totalSavings += lineDiscount;
            if (unitEl) unitEl.textContent = (discUnit / 100).toFixed(2).replace('.', ',') + ' zł';
          } else {
            el.style.display = 'none';
          }
        });
        var savingsBox = document.getElementById('cart-drawer-savings');
        var savingsVal = document.getElementById('cart-drawer-savings-val');
        if (savingsBox && savingsVal) {
          if (totalSavings > 0) {
            savingsVal.textContent = (totalSavings / 100).toFixed(2).replace('.', ',') + ' zł';
            savingsBox.style.display = 'flex';
          } else {
            savingsBox.style.display = 'none';
          }
        }
      });
    });
}

$(document).on('cart.requestComplete cart.ready', function() {
  setTimeout(phoneoApplyComparePrices, 200);
});

$(window).on('load', function() {
  [0, 600, 1500].forEach(function(d) { setTimeout(phoneoApplyComparePrices, d); });
});

setTimeout(phoneoApplyComparePrices, 2000);
/* ============================================================
   MINI-CART: progress bar + recommendations
   ============================================================ */

(function() {
  var MONEY_FORMAT = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '{{amount}} zł';

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' zł';
  }

  function phoneoCartProgress(totalCents) {
    var el = document.querySelector('.cart-freeship[data-threshold]');
    if (!el) return;
    var threshold = parseInt(el.getAttribute('data-threshold'), 10);
    if (!threshold) return;
    var fill = document.getElementById('freeShipFill');
    var msgPending = document.getElementById('freeShipMsgNew');
    var msgAchieved = document.getElementById('freeShipClaimNew');
    var amountEl = document.getElementById('freeShipAmount');

    var pct = Math.min(100, Math.round((totalCents / threshold) * 100));
    if (fill) fill.style.width = pct + '%';

    if (totalCents >= threshold) {
      if (msgPending) msgPending.style.display = 'none';
      if (msgAchieved) msgAchieved.style.display = '';
    } else {
      if (msgPending) msgPending.style.display = '';
      if (msgAchieved) msgAchieved.style.display = 'none';
      if (amountEl) amountEl.textContent = formatMoney(threshold - totalCents);
    }
  }

  function phoneoCartRecs(cart) {
    var recEl = document.getElementById('cart-recs');
    var listEl = document.getElementById('cart-recs-list');
    if (!recEl || !listEl) return;

    var threshold = 0;
    var fsEl = document.querySelector('.cart-freeship[data-threshold]');
    if (fsEl) threshold = parseInt(fsEl.getAttribute('data-threshold'), 10);
    if (!threshold) { recEl.style.display = 'none'; return; }

    var totalCents = cart.total_price || 0;
    if (totalCents >= threshold) { recEl.style.display = 'none'; return; }

    var missingCents = threshold - totalCents;
    var firstItem = cart.items && cart.items.length ? cart.items[0] : null;
    if (!firstItem) { recEl.style.display = 'none'; return; }

    function getImgSrc(p) {
      var src = '';
      if (p.featured_image) {
        src = (typeof p.featured_image === 'string') ? p.featured_image : (p.featured_image.src || '');
      } else if (p.images && p.images.length) {
        src = p.images[0].src || p.images[0] || '';
      }
      if (src) src = src.indexOf('?') !== -1 ? src + '&width=240' : src + '?width=240';
      return src;
    }

    function buildCard(url, img, safeTitle, title, variantId, price) {
      var btnAttr = variantId ? 'data-variant-id="' + variantId + '"' : 'data-product-url="' + url + '"';
      return '<div class="cart-rec-item">' +
        '<div class="cart-rec-item__img-wrap">' +
        '<a href="' + url + '">' +
        (img ? '<img src="' + img + '" alt="' + safeTitle + '" width="120" height="120" loading="lazy">' : '<div style="width:120px;height:120px;background:#f5f5f5;border-radius:8px;"></div>') +
        '</a>' +
        '<button class="cart-rec-item__add" ' + btnAttr + ' title="Dodaj do koszyka" type="button">+</button>' +
        '</div>' +
        '<div class="cart-rec-item__title">' + title + '</div>' +
        '<div class="cart-rec-item__price">' + price + '</div>' +
        '</div>';
    }

    function renderRecs(products) {
      if (!products || products.length === 0) { recEl.style.display = 'none'; return; }
      var filtered = products.filter(function(p) { return p.price <= missingCents * 2; }).slice(0, 8);
      if (!filtered.length) filtered = products.slice(0, 8);
      listEl.innerHTML = filtered.map(function(p) {
        return buildCard(p.url, getImgSrc(p), p.title.replace(/'/g, '&#39;').replace(/"/g, '&quot;'), p.title, p.variants && p.variants[0] ? p.variants[0].id : '', formatMoney(p.price));
      }).join('');
      recEl.style.display = '';
    }

    var SZKLO_WORDS = ['szkł', 'szklo', 'hartowane', 'hartowanego', 'screen protector', 'tempered'];
    var ETUI_WORDS = ['etui', 'case', 'pokrowiec', 'obudow'];

    function titleMatches(title, words) {
      var t = (title || '').toLowerCase();
      for (var i = 0; i < words.length; i++) { if (t.indexOf(words[i]) !== -1) return true; }
      return false;
    }

    function renderSuggestRecs(products, filterFor) {
      if (!products || products.length === 0) { recEl.style.display = 'none'; return; }
      var filtered = products.filter(function(p) {
        if (filterFor === 'etui') return !titleMatches(p.title, SZKLO_WORDS);
        if (filterFor === 'ochrona ekranu') return !titleMatches(p.title, ETUI_WORDS);
        return true;
      });
      if (!filtered.length) filtered = products;
      var items = filtered.slice(0, 8);
      listEl.innerHTML = items.map(function(p) {
        var img = p.image ? (p.image.src || p.image) : '';
        if (img) img = img.indexOf('?') !== -1 ? img + '&width=240' : img + '?width=240';
        var variantId = p.variants && p.variants[0] ? p.variants[0].id : '';
        var priceCents = p.price_min ? Math.round(parseFloat(p.price_min) * 100) : 0;
        var safeTitle = (p.title || '').replace(/'/g, '&#39;').replace(/"/g, '&quot;');
        return buildCard(p.url || '/products/' + p.handle, img, safeTitle, p.title || '', variantId, formatMoney(priceCents));
      }).join('');
      recEl.style.display = '';
    }

    function fetchFallback() {
      var colHandle = window.phoneoCartRecCollection || 'all';
      $.ajax({
        url: '/collections/' + colHandle + '/products.json?limit=12',
        dataType: 'json',
        success: function(data) { renderRecs(data.products || []); },
        error: function() { recEl.style.display = 'none'; }
      });
    }

    function fetchRecommendations(productId) {
      $.ajax({
        url: '/recommendations/products.json?product_id=' + productId + '&limit=12',
        dataType: 'json',
        success: function(data) {
          if (data.products && data.products.length) { renderRecs(data.products); } else { fetchFallback(); }
        },
        error: function() { fetchFallback(); }
      });
    }

    function fetchCrossSell(targetTag, modelTag) {
      var q = 'tag:"' + targetTag + '"';
      if (modelTag) q += ' tag:"' + modelTag + '"';
      $.ajax({
        url: '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][prefix]=last',
        dataType: 'json',
        success: function(data) {
          var products = data.resources && data.resources.results && data.resources.results.products || [];
          if (products.length) { renderSuggestRecs(products, targetTag); } else { fetchRecommendations(firstItem.product_id); }
        },
        error: function() { fetchRecommendations(firstItem.product_id); }
      });
    }

    var handle = firstItem.url ? firstItem.url.replace(/^\/products\//, '').split('?')[0] : null;

    if (handle) {
      $.ajax({
        url: '/products/' + handle + '.js',
        dataType: 'json',
        success: function(product) {
          var rawTags = product.tags || '';
          var tags = typeof rawTags === 'string' ? rawTags.split(',').map(function(t) { return t.trim(); }) : rawTags;
          var tagsLower = tags.map(function(t) { return t.toLowerCase(); });
          var isEtui = tagsLower.indexOf('etui') !== -1;
          var isOchrona = tagsLower.indexOf('ochrona ekranu') !== -1;
          if (isEtui || isOchrona) {
            var targetTag = isEtui ? 'ochrona ekranu' : 'etui';
            var phoneKeywords = ['iphone', 'samsung', 'xiaomi', 'huawei', 'google pixel', 'motorola', 'oppo', 'sony', 'oneplus', 'realme', 'nothing', 'honor', 'poco'];
            var modelTag = null;
            var modelTagLen = 0;
            for (var i = 0; i < tagsLower.length; i++) {
              var tl = tagsLower[i];
              if (tl === 'etui' || tl === 'ochrona ekranu') continue;
              var isPhone = false;
              for (var k = 0; k < phoneKeywords.length; k++) {
                if (tl.indexOf(phoneKeywords[k]) !== -1) { isPhone = true; break; }
              }
              if (isPhone && tl.length > modelTagLen) {
                modelTag = tags[i];
                modelTagLen = tl.length;
              }
            }
            if (!modelTag) {
              fetchRecommendations(firstItem.product_id);
            } else {
              fetchCrossSell(targetTag, modelTag);
            }
          } else {
            fetchRecommendations(firstItem.product_id);
          }
        },
        error: function() { fetchRecommendations(firstItem.product_id); }
      });
    } else {
      fetchRecommendations(firstItem.product_id);
    }
  }

  function onCartUpdate(cart) {
    phoneoCartProgress(cart.total_price || 0);
    phoneoCartRecs(cart);
  }

  $(document).on('cart.requestComplete', function(e, cart) {
    onCartUpdate(cart);
  });

  $(document).on('click', '.drawer-qty__btn', function(e) {
    e.preventDefault();
    var btn = $(this);
    var line = parseInt(btn.data('line'), 10);
    var action = btn.data('action');
    if (!line || !CartJS || !CartJS.cart || !CartJS.cart.items[line - 1]) return;
    var current = CartJS.cart.items[line - 1].quantity;
    var newQty = action === 'plus' ? current + 1 : current - 1;
    if (newQty < 1) {
      CartJS.removeItem(line);
    } else {
      CartJS.updateItem(line, newQty);
    }
  });

  $(document).on('click', '.cart-rec-item__add', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var btn = $(this);
    var variantId = parseInt(btn.data('variant-id'), 10);
    if (!variantId) {
      var productUrl = btn.data('product-url');
      if (!productUrl) return;
      var handle = String(productUrl).replace(/^\/products\//, '').split('?')[0];
      btn.prop('disabled', true).text('...');
      $.ajax({ url: '/products/' + handle + '.js', dataType: 'json',
        success: function(product) {
          var variants = product.variants || [];
          var v = null;
          for (var i = 0; i < variants.length; i++) {
            if (variants[i].available) { v = variants[i]; break; }
          }
          if (!v && variants.length) v = variants[0];
          if (v && v.id) {
            btn.attr('data-variant-id', v.id);
            CartJS.addItem(v.id, 1, {}, {
              success: function() { btn.text('+').prop('disabled', false); },
              error: function() { btn.text('+').prop('disabled', false); }
            });
          } else { btn.prop('disabled', false).text('+'); }
        },
        error: function() { btn.prop('disabled', false).text('+'); }
      });
      return;
    }
    btn.prop('disabled', true).text('...');
    CartJS.addItem(variantId, 1, {}, {
      success: function() { btn.text('+').prop('disabled', false); },
      error: function() { btn.text('+').prop('disabled', false); }
    });
  });

  $(document).ready(function() {
    if (window.CartJS && CartJS.cart) {
      onCartUpdate(CartJS.cart);
    }
  });
})();

/* ============================================================
   CART PAGE V2
   ============================================================ */

(function() {
  if (!document.querySelector('.cp-wrap')) return;

  /* --- Helpers --- */
  function cpFmt(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' zł';
  }

  function cpUpdateProgress(totalCents) {
    var el = document.querySelector('.cp-ship[data-threshold]');
    if (!el) return;
    var threshold = parseInt(el.getAttribute('data-threshold'), 10);
    if (!threshold) return;
    var pct = Math.min(100, Math.round((totalCents / threshold) * 100));
    var fill    = document.getElementById('cp-ship-fill');
    var pending = document.getElementById('cp-ship-pending');
    var achieved= document.getElementById('cp-ship-achieved');
    var amountEl= document.getElementById('cp-ship-amount');
    var current = document.getElementById('cp-ship-current');
    if (fill)    fill.style.width = pct + '%';
    if (current) current.textContent = cpFmt(totalCents);
    if (totalCents >= threshold) {
      if (pending)  pending.style.display  = 'none';
      if (achieved) achieved.style.display = '';
    } else {
      if (pending)  pending.style.display  = '';
      if (achieved) achieved.style.display = 'none';
      if (amountEl) amountEl.textContent = cpFmt(threshold - totalCents);
    }
  }

  function cpUpdatePrices(totalCents) {
    var sub = document.getElementById('revy-cart-subtotal-price');
    if (sub) sub.textContent = cpFmt(totalCents);
    var mob = document.getElementById('cp-mob-price');
    if (mob) mob.textContent = cpFmt(totalCents);
    cpUpdateProgress(totalCents);
  }

  /* --- Accordions --- */
  $(document).on('click', '.cp-acc__btn', function() {
    var $body = $(this).next('.cp-acc__body');
    var $icon = $(this).find('.cp-acc__icon');
    var isOpen = !$body.prop('hidden');
    $body.prop('hidden', isOpen);
    $icon.toggleClass('cp-acc__icon--open', !isOpen);
  });

  /* --- Quantity stepper (form auto-submit) --- */
  var cpQtyTimer;
  $(document).on('click', '.cp-qty__btn', function() {
    var action = $(this).data('action');
    var $input = $(this).siblings('.cp-qty__val');
    var cur = parseInt($input.val(), 10) || 1;
    var nv = action === 'plus' ? cur + 1 : Math.max(0, cur - 1);
    $input.val(nv);
    clearTimeout(cpQtyTimer);
    cpQtyTimer = setTimeout(function() {
      $('#cp-form').submit();
    }, 500);
  });

  /* --- Note character counter --- */
  $(document).on('input', '#CartSpecialInstructions', function() {
    var cnt = document.getElementById('cp-note-cnt');
    if (cnt) cnt.textContent = $(this).val().length;
  });

  /* --- Discount redirect --- */
  function cpGoToCheckout(code) {
    var note = $('#CartSpecialInstructions').val() || '';
    var nip  = $('#CartCustomNip').val() || '';
    var data = { note: note };
    if (nip) data['attributes[NIP]'] = nip;
    $.ajax({
      type: 'POST', url: '/cart/update.js', data: data, dataType: 'json',
      complete: function() {
        window.location.href = '/checkout?discount=' + encodeURIComponent(code);
      }
    });
  }

  $('#cp-discount-btn').on('click', function() {
    var code = $('#cp-discount-code').val().trim();
    if (!code) { $('#cp-discount-code').focus(); return; }
    cpGoToCheckout(code);
  });

  $('#cp-discount-code').on('keydown', function(e) {
    if (e.which === 13) { e.preventDefault(); $('#cp-discount-btn').trigger('click'); }
  });

  /* When checkout is clicked with a discount code in the field, apply it */
  $(document).on('click', '#cp-checkout-btn, .cp-mob-cta__btn', function(e) {
    var code = $('#cp-discount-code').val().trim();
    if (!code) return;
    e.preventDefault();
    cpGoToCheckout(code);
  });

  /* --- Add-to-cart from modules (Strzał dnia, Etap 2) --- */
  $(document).on('click', '.cp-add-btn', function(e) {
    e.preventDefault();
    var $btn = $(this);
    var vid = parseInt($btn.data('variant-id'), 10);
    var origText = $btn.text();

    function doAdd(variantId) {
      $btn.prop('disabled', true).text('...');
      CartJS.addItem(variantId, 1, {}, {
        success: function() {
          $btn.text('✓').addClass('cp-add-btn--added');
          setTimeout(function() { window.location.reload(); }, 1000);
        },
        error: function() {
          $btn.prop('disabled', false).text(origText);
        }
      });
    }

    if (vid) { doAdd(vid); return; }

    var productUrl = $btn.data('product-url');
    if (!productUrl) return;
    var handle = String(productUrl).replace(/^\/products\//, '').split('?')[0];
    $btn.prop('disabled', true).text('...');
    $.ajax({ url: '/products/' + handle + '.js', dataType: 'json',
      success: function(product) {
        var variants = product.variants || [];
        var v = null;
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].available) { v = variants[i]; break; }
        }
        if (!v && variants.length) v = variants[0];
        if (v && v.id) { $btn.attr('data-variant-id', v.id); doAdd(v.id); }
        else { $btn.prop('disabled', false).text(origText); }
      },
      error: function() { $btn.prop('disabled', false).text(origText); }
    });
  });

  /* --- Helpers --- */
  var CP_SZKLO  = ['szkł', 'szklo', 'hartowane', 'screen protector', 'tempered', 'folia', 'hydrożel', 'hydrozel', 'ochrona ekranu', 'privacy'];
  var CP_ETUI   = ['etui', 'case', 'pokrowiec', 'obudow', 'portfel', 'wallet', 'kieszeń', 'kieszeni', 'flip', 'folio'];
  var CP_PHONES = ['iphone', 'samsung', 'xiaomi', 'huawei', 'google pixel', 'motorola', 'oppo', 'sony', 'oneplus', 'realme', 'nothing', 'honor', 'poco'];

  var cpShownIds = {};
  var cpCartTypes = [];

  var CP_ETUI_CART  = ['etui', 'pokrowiec', 'obudow'];
  var CP_SZKLO_CART = ['szkł', 'szklo', 'hartowane', 'screen protector', 'tempered', 'hydrożel', 'hydrozel', 'ochrona ekranu'];

  function cpDetectCartTypes(cart) {
    cpCartTypes = [];
    (cart.items || []).forEach(function(item) {
      var t = (item.title || '').toLowerCase();
      if (cpTitleMatchWord(t, CP_ETUI_CART) && cpCartTypes.indexOf('etui') === -1) cpCartTypes.push('etui');
      if (cpTitleMatchWord(t, CP_SZKLO_CART) && cpCartTypes.indexOf('szklo') === -1) cpCartTypes.push('szklo');
    });
  }

  function cpIsProtection(p) {
    if (p.tags) {
      var tl = (Array.isArray(p.tags) ? p.tags : String(p.tags).split(',')).map(function(t) { return t.trim().toLowerCase(); });
      if (tl.indexOf('etui') !== -1 || tl.indexOf('ochrona ekranu') !== -1 || tl.indexOf('case') !== -1) return true;
    }
    var pt = (p.product_type || '').toLowerCase();
    if (pt && (cpTitleMatch(pt, CP_ETUI) || cpTitleMatch(pt, CP_SZKLO))) return true;
    return cpTitleMatch(p.title || '', CP_ETUI) || cpTitleMatch(p.title || '', CP_SZKLO);
  }

  function cpMarkShown(products) {
    (products || []).forEach(function(p) { if (p && p.id) cpShownIds[p.id] = true; });
  }

  function cpFilterShown(products) {
    return products.filter(function(p) { return p && p.id && !cpShownIds[p.id]; });
  }

  function cpTitleMatch(title, words) {
    var t = (title || '').toLowerCase();
    for (var i = 0; i < words.length; i++) { if (t.indexOf(words[i]) !== -1) return true; }
    return false;
  }

  function cpTitleMatchWord(title, words) {
    var t = (title || '').toLowerCase();
    for (var i = 0; i < words.length; i++) {
      var w = words[i], idx = t.indexOf(w);
      while (idx !== -1) {
        var after = t[idx + w.length];
        if (after === undefined || /[\s,\-\/\.\(\)_]/.test(after)) return true;
        idx = t.indexOf(w, idx + 1);
      }
    }
    return false;
  }

  function cpGetImg(p, size) {
    var src = (p.featured_image && (p.featured_image.src || p.featured_image)) ||
              (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    return src ? (src.indexOf('?') !== -1 ? src + '&width=' + size : src + '?width=' + size) : '';
  }

  function cpInCartMap(cart) {
    var map = {};
    (cart.items || []).forEach(function(it) { map[it.product_id] = true; });
    return map;
  }

  function cpGetModelTag(tagsLower, tags) {
    var modelTag = null, modelLen = 0;
    tagsLower.forEach(function(t, i) {
      if (t === 'etui' || t === 'ochrona ekranu') return;
      if (CP_PHONES.some(function(ph) { return t.indexOf(ph) !== -1; }) && t.length > modelLen) {
        modelTag = tags[i]; modelLen = t.length;
      }
    });
    return modelTag;
  }

  function cpFetchTags(handle, cb) {
    $.ajax({ url: '/products/' + handle + '.js', dataType: 'json',
      success: function(product) {
        var tags = typeof product.tags === 'string' ? product.tags.split(',').map(function(t) { return t.trim(); }) : (product.tags || []);
        cb(tags, tags.map(function(t) { return t.toLowerCase(); }));
      },
      error: function() { cb([], []); }
    });
  }

  function cpFetchCrossSell(targetTag, modelTag, limit, cb) {
    var q = 'tag:"' + targetTag + '"' + (modelTag ? ' tag:"' + modelTag + '"' : '');
    $.ajax({ url: '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=' + limit + '&resources[options][prefix]=last',
      dataType: 'json',
      success: function(d) {
        var prods = (d.resources && d.resources.results && d.resources.results.products) || [];
        cb(prods.map(function(p) {
          return { id: p.id, available: p.available !== false, title: p.title || '',
                   url: p.url || '/products/' + p.handle,
                   price: p.price_min ? Math.round(parseFloat(p.price_min) * 100) : (p.price || 0),
                   featured_image: p.image || null, variants: p.variants || [],
                   product_type: p.product_type || '' };
        }));
      },
      error: function() { cb([]); }
    });
  }

  /* --- Moduł 2: Uzupełnij ochronę telefonu --- */
  function cpBuildProtectionCard(url, img, title, variantId, priceCents) {
    var btnAttr = variantId ? 'data-variant-id="' + variantId + '"' : 'data-product-url="' + url + '"';
    var safe = (title || '').replace(/'/g, '&#39;').replace(/"/g, '&quot;');
    return '<div class="cp-protection-item">' +
      '<div class="cp-protection-item__img-wrap">' +
        '<a href="' + url + '">' +
          (img ? '<img src="' + img + '" alt="' + safe + '" class="cp-protection-item__img" width="120" height="120" loading="lazy">' : '') +
        '</a>' +
        '<button type="button" class="cp-protection-item__add cp-add-btn" ' + btnAttr + '>+</button>' +
      '</div>' +
      '<a href="' + url + '" class="cp-protection-item__name">' + title + '</a>' +
      '<div class="cp-protection-item__price">' + cpFmt(priceCents) + '</div>' +
    '</div>';
  }

  function cpLoadProtection(cart, done) {
    var el = document.getElementById('cp-protection');
    var listEl = document.getElementById('cp-protection-list');
    done = done || function() {};
    if (!el || !listEl) { done(); return; }

    var hasEtui = cpCartTypes.indexOf('etui') !== -1;
    var hasSzklo = cpCartTypes.indexOf('szklo') !== -1;
    if (!hasEtui && !hasSzklo) { el.style.display = 'none'; done(); return; }

    var targetTag = hasEtui ? 'ochrona ekranu' : 'etui';
    var sourceWords = hasEtui ? CP_ETUI : CP_SZKLO;
    var sourceItem = null;
    for (var i = 0; i < (cart.items || []).length; i++) {
      if (cpTitleMatch((cart.items[i].title || '').toLowerCase(), sourceWords)) {
        sourceItem = cart.items[i]; break;
      }
    }
    if (!sourceItem) { el.style.display = 'none'; done(); return; }

    var inCart = cpInCartMap(cart);

    function render(products) {
      var list = cpFilterShown(products.filter(function(p) { return p.available !== false && !inCart[p.id]; }));
      if (!list.length) { el.style.display = 'none'; done(); return; }
      var items = list.slice(0, 8);
      listEl.innerHTML = items.map(function(p) {
        var vid = p.variants && p.variants[0] ? p.variants[0].id : '';
        return cpBuildProtectionCard(p.url || '/products/' + p.handle, cpGetImg(p, 240), p.title || '', vid, p.price || 0);
      }).join('');
      cpMarkShown(items);
      el.style.display = '';
      cpInitCarousel('cp-protection-list');
      done();
    }

    var handle = sourceItem.url ? sourceItem.url.replace(/^\/products\//, '').split('?')[0] : null;
    if (!handle) {
      cpFetchCrossSell(targetTag, null, 12, function(products) {
        if (products.length) render(products); else { el.style.display = 'none'; done(); }
      });
      return;
    }

    cpFetchTags(handle, function(tags, tl) {
      var modelTag = cpGetModelTag(tl, tags);
      cpFetchCrossSell(targetTag, modelTag, 12, function(products) {
        if (products.length) render(products); else { el.style.display = 'none'; done(); }
      });
    });
  }

  /* --- Moduł 3: Dobierz do darmowej dostawy (lewa kolumna) --- */
  function cpBuildDobierzCard(url, img, title, variantId, priceCents) {
    var btnAttr = variantId ? 'data-variant-id="' + variantId + '"' : 'data-product-url="' + url + '"';
    var safe = (title || '').replace(/'/g, '&#39;').replace(/"/g, '&quot;');
    return '<div class="cp-dobierz-item">' +
      '<div class="cp-dobierz-item__img-wrap">' +
        '<a href="' + url + '" class="cp-dobierz-item__img-link">' +
          (img ? '<img src="' + img + '" alt="' + safe + '" class="cp-dobierz-item__img" width="80" height="80" loading="lazy">' : '') +
        '</a>' +
        '<button type="button" class="cp-dobierz-item__add cp-add-btn" ' + btnAttr + '>+</button>' +
      '</div>' +
      '<a href="' + url + '" class="cp-dobierz-item__name">' + title + '</a>' +
      '<div class="cp-dobierz-item__price">+' + cpFmt(priceCents) + '</div>' +
    '</div>';
  }

  function cpLoadDobierz(cart, done) {
    var el = document.getElementById('cp-dobierz');
    var listEl = document.getElementById('cp-dobierz-list');
    done = done || function() {};
    if (!el || !listEl) { done(); return; }

    var threshold = 0;
    var shipEl = document.querySelector('.cp-ship[data-threshold]');
    if (shipEl) threshold = parseInt(shipEl.getAttribute('data-threshold'), 10);
    if (!threshold || (cart.total_price || 0) >= threshold) { el.style.display = 'none'; done(); return; }

    var totalCents = cart.total_price || 0;
    var missingCents = threshold - totalCents;
    var firstItem = cart.items && cart.items.length ? cart.items[0] : null;
    if (!firstItem) { el.style.display = 'none'; done(); return; }

    var msgEl = document.getElementById('cp-dobierz-msg');
    var fillEl = document.getElementById('cp-dobierz-fill');
    var curEl  = document.getElementById('cp-dobierz-current');
    var thrEl  = document.getElementById('cp-dobierz-threshold');
    if (msgEl) msgEl.textContent = 'Brakuje Ci ' + cpFmt(missingCents) + ' do darmowej dostawy';
    var pct = Math.min(100, Math.round((totalCents / threshold) * 100));
    if (fillEl) fillEl.style.width = pct + '%';
    if (curEl)  curEl.textContent  = cpFmt(totalCents);
    if (thrEl)  thrEl.textContent  = cpFmt(threshold);

    var inCart = cpInCartMap(cart);

    var cartProductTypes = {};
    (cart.items || []).forEach(function(item) {
      if (item.product_type) cartProductTypes[item.product_type.toLowerCase()] = true;
    });

    var hasProtection = cpCartTypes.indexOf('etui') !== -1 || cpCartTypes.indexOf('szklo') !== -1;

    function applyFilter(products) {
      return cpFilterShown(products.filter(function(p) {
        if (p.available === false || inCart[p.id]) return false;
        if (p.product_type && cartProductTypes[p.product_type.toLowerCase()]) return false;
        if (hasProtection && cpIsProtection(p)) return false;
        return true;
      }));
    }

    function render(list) {
      var byPrice = list.filter(function(p) { return p.price <= missingCents * 2; });
      if (!byPrice.length) byPrice = list;
      var items = byPrice.slice(0, 20);
      listEl.innerHTML = items.map(function(p) {
        var vid = p.variants && p.variants[0] ? p.variants[0].id : '';
        return cpBuildDobierzCard(p.url || '/products/' + p.handle, cpGetImg(p, 160), p.title || '', vid, p.price || 0);
      }).join('');
      cpMarkShown(items);
      el.style.display = '';
      cpInitCarousel('cp-dobierz-list');
      done();
    }

    function bestSellingFallback() {
      $.ajax({ url: '/collections/all/products.json?sort_by=best-selling&limit=200',
        dataType: 'json',
        success: function(d) {
          var prods = (d.products || []).map(function(p) {
            var v0 = p.variants && p.variants[0];
            return { id: p.id, available: v0 ? v0.available !== false : false,
                     title: p.title || '', url: '/products/' + p.handle,
                     price: v0 ? Math.round(parseFloat(v0.price) * 100) : 0,
                     featured_image: p.images && p.images[0] ? p.images[0] : null,
                     variants: p.variants || [], product_type: p.product_type || '',
                     tags: p.tags || '' };
          });
          var list = applyFilter(prods);
          if (!list.length) { el.style.display = 'none'; done(); return; }
          render(list);
        },
        error: function() { el.style.display = 'none'; done(); }
      });
    }

    $.ajax({ url: '/recommendations/products.json?product_id=' + firstItem.product_id + '&limit=25',
      dataType: 'json',
      success: function(d) {
        var list = applyFilter(d.products || []);
        if (!list.length) { bestSellingFallback(); return; }
        render(list);
      },
      error: function() { bestSellingFallback(); }
    });
  }

  /* --- Moduł 4: Pasuje do Twojego koszyka (Recommendations API) --- */
  function cpBuildRecsCard(url, img, title, variantId, priceCents) {
    var btnAttr = variantId ? 'data-variant-id="' + variantId + '"' : 'data-product-url="' + url + '"';
    var safe = (title || '').replace(/'/g, '&#39;').replace(/"/g, '&quot;');
    return '<div class="cp-recs-item">' +
      '<div class="cp-recs-item__img-wrap">' +
        '<a href="' + url + '">' +
          (img ? '<img src="' + img + '" alt="' + safe + '" class="cp-recs-item__img" width="130" height="100" loading="lazy">' :
                 '<div class="cp-recs-item__img cp-recs-item__img--empty"></div>') +
        '</a>' +
        '<button type="button" class="cp-recs-item__add cp-add-btn" ' + btnAttr + '>+</button>' +
      '</div>' +
      '<a href="' + url + '" class="cp-recs-item__name">' + title + '</a>' +
      '<div class="cp-recs-item__price">' + cpFmt(priceCents) + '</div>' +
    '</div>';
  }

  function cpLoadRecs(cart, done) {
    var el = document.getElementById('cp-recs');
    var listEl = document.getElementById('cp-recs-list');
    done = done || function() {};
    if (!el || !listEl) { done(); return; }

    if (!cart.items || !cart.items.length) { el.style.display = 'none'; done(); return; }

    var inCart = cpInCartMap(cart);

    function recsFilter(products) {
      return cpFilterShown(products.filter(function(p) {
        if (!p.id || inCart[p.id]) return false;
        if (p.available === false) return false;
        if (cpIsProtection(p)) return false;
        return true;
      }));
    }

    function recsRender(list) {
      var items = list.slice(0, 20);
      listEl.innerHTML = items.map(function(p) {
        var vid = p.variants && p.variants[0] ? p.variants[0].id : '';
        return cpBuildRecsCard(p.url || '/products/' + p.handle, cpGetImg(p, 280), p.title || '', vid, p.price || 0);
      }).join('');
      cpMarkShown(items);
      el.style.display = '';
      cpInitCarousel('cp-recs-list');
      done();
    }

    function recsFallback() {
      $.ajax({ url: '/collections/all/products.json?sort_by=best-selling&limit=200',
        dataType: 'json',
        success: function(d) {
          var prods = (d.products || []).map(function(p) {
            var v0 = p.variants && p.variants[0];
            return { id: p.id, available: v0 ? v0.available !== false : false,
                     title: p.title || '', url: '/products/' + p.handle,
                     price: v0 ? Math.round(parseFloat(v0.price) * 100) : 0,
                     featured_image: p.images && p.images[0] ? p.images[0] : null,
                     variants: p.variants || [], product_type: p.product_type || '',
                     tags: p.tags || '' };
          });
          var list = recsFilter(prods);
          if (!list.length) { el.style.display = 'none'; done(); return; }
          recsRender(list);
        },
        error: function() { el.style.display = 'none'; done(); }
      });
    }

    var cartItems = (cart.items || []).filter(function(i) { return i.product_id; });
    var itemIdx = 0;
    var MAX_TRIES = 3;
    function tryNextItem() {
      if (itemIdx >= cartItems.length || itemIdx >= MAX_TRIES) { recsFallback(); return; }
      var pid = cartItems[itemIdx++].product_id;
      $.ajax({ url: '/recommendations/products.json?product_id=' + pid + '&limit=50',
        dataType: 'json',
        success: function(d) {
          var list = recsFilter(d.products || []);
          if (list.length < 3) { tryNextItem(); return; }
          recsRender(list);
        },
        error: function() { tryNextItem(); }
      });
    }
    tryNextItem();
  }

  /* --- Moduł 9: Szybkie dodatki (sidebar — najnowsze produkty) --- */
  function cpBuildUpsellCard(url, img, title, variantId, priceCents) {
    var btnAttr = variantId ? 'data-variant-id="' + variantId + '"' : 'data-product-url="' + url + '"';
    var safe = (title || '').replace(/'/g, '&#39;').replace(/"/g, '&quot;');
    return '<div class="cp-upsell-item">' +
      '<a href="' + url + '" class="cp-upsell-item__img-link">' +
        (img ? '<img src="' + img + '" alt="' + safe + '" class="cp-upsell-item__img" width="56" height="56" loading="lazy">' : '') +
      '</a>' +
      '<div class="cp-upsell-item__info">' +
        '<a href="' + url + '" class="cp-upsell-item__name">' + title + '</a>' +
        '<div class="cp-upsell-item__price">' + cpFmt(priceCents) + '</div>' +
      '</div>' +
      '<button type="button" class="cp-upsell-item__add cp-add-btn" ' + btnAttr + '>+</button>' +
    '</div>';
  }

  function cpLoadUpsell(cart) {
    var el = document.getElementById('cp-upsell');
    var listEl = document.getElementById('cp-upsell-list');
    if (!el || !listEl) return;

    var inCart = cpInCartMap(cart);

    $.ajax({ url: '/products.json?limit=20',
      dataType: 'json',
      success: function(d) {
        var list = (d.products || [])
          .filter(function(p) { return !inCart[p.id]; })
          .sort(function(a, b) { return b.id - a.id; });
        if (!list.length) { el.style.display = 'none'; return; }
        var items = list.slice(0, 4);
        listEl.innerHTML = items.map(function(p) {
          var vid = p.variants && p.variants[0] ? p.variants[0].id : '';
          var price = p.variants && p.variants[0] ? Math.round(parseFloat(p.variants[0].price) * 100) : 0;
          return cpBuildUpsellCard(p.url || '/products/' + p.handle, cpGetImg(p, 120), p.title || '', vid, price);
        }).join('');
        el.style.display = '';
      },
      error: function() { el.style.display = 'none'; }
    });
  }

  /* --- Carousel: strzałki lewo/prawo dla cp-module__list --- */
  function cpInitCarousel(listId) {
    var list = document.getElementById(listId);
    if (!list) return;
    var wrap = list.parentNode;
    if (!wrap || !wrap.classList.contains('cp-carousel-wrap')) return;
    var prev = wrap.querySelector('.cp-carousel-prev');
    var next = wrap.querySelector('.cp-carousel-next');
    if (!prev || !next) return;

    function updateBtns() {
      var atStart = list.scrollLeft <= 2;
      var atEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
      prev.classList.toggle('is-hidden', atStart);
      next.classList.toggle('is-hidden', atEnd);
    }

    prev.addEventListener('click', function() { list.scrollBy({ left: -280, behavior: 'smooth' }); });
    next.addEventListener('click', function() { list.scrollBy({ left: 280, behavior: 'smooth' }); });
    list.addEventListener('scroll', updateBtns);
    setTimeout(updateBtns, 50);
  }

  /* --- Łańcuch ładowania (cpShownIds gwarantuje kolejność) --- */
  function cpLoadAll(cart) {
    cpShownIds = {};
    cpDetectCartTypes(cart);
    cpUpdateProgress(cart.total_price || 0);
    cpLoadProtection(cart, function() {
      cpLoadDobierz(cart, function() {
        cpLoadRecs(cart, function() {
          cpLoadUpsell(cart);
        });
      });
    });
  }

  /* --- Strzał dnia: timer --- */
  (function() {
    var hEl = document.getElementById('cp-deal-h');
    var mEl = document.getElementById('cp-deal-m');
    var sEl = document.getElementById('cp-deal-s');
    if (hEl && mEl && sEl) {
      function tick() {
        var now = new Date();
        var midnight = new Date(now);
        midnight.setHours(24, 0, 0, 0);
        var diff = Math.max(0, Math.floor((midnight - now) / 1000));
        var h = Math.floor(diff / 3600);
        var m = Math.floor((diff % 3600) / 60);
        var s = diff % 60;
        hEl.textContent = (h < 10 ? '0' : '') + h;
        mEl.textContent = (m < 10 ? '0' : '') + m;
        sEl.textContent = (s < 10 ? '0' : '') + s;
      }
      tick();
      setInterval(tick, 1000);
    }
  })();

  /* --- Sync prices on cart.requestComplete --- */
  $(document).on('cart.requestComplete', function(e, cart) {
    cpUpdatePrices(cart.total_price || 0);
    cpLoadAll(cart);
  });

  /* --- Initial state --- */
  $(document).ready(function() {
    if (window.CartJS && CartJS.cart) {
      cpLoadAll(CartJS.cart);
    }
  });

})();

// Mobile bottom nav + scroll hide/show #mob-header
(function(){
  if (window.innerWidth > 768) return;

  var bn = document.getElementById('mob-bottom-nav');
  if (bn) bn.style.display = 'flex';

  var hd = document.getElementById('mob-header');
  if (!hd) return;
  var lastY = 0, ticking = false;
  function update() {
    var y = window.pageYOffset;
    if (y > lastY && y > 80) { hd.classList.add('mob-scroll-hide'); }
    else { hd.classList.remove('mob-scroll-hide'); }
    lastY = y;
    ticking = false;
  }
  window.addEventListener('scroll', function(){
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, {passive: true});
})();

/* ===== SEARCH REDESIGN ===== */
$(document).ready(function() {
  // Remove old search-results ul injected by theme.min.js
  $('form[action="/search"] ul.search-results').remove();
  // Unbind old keyup/change from search inputs
  $('form[action="/search"] input[name="q"]').off('keyup change').removeAttr('data-old-term');

  function srHighlight(text, term) {
    if (!term) return text;
    var esc = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return text.replace(new RegExp('(' + esc + ')', 'gi'), '<mark>$1</mark>');
  }

  function srCatsFromResults(results, term) {
    if (!window.theme || !theme.menuCollections) return [];
    var menuByUrl = {};
    $.each(theme.menuCollections, function(i, c) { menuByUrl[c.url] = c; });
    var lower = term.toLowerCase();
    var strictMatch = /iphone|galaxy|samsung/i.test(term);
    var strictWords = strictMatch
      ? lower.split(/\s+/).filter(function(w) { return w.length > 1 && w !== 'samsung'; })
      : [];
    var seen = {};
    var cats = [];
    $.each(results, function(i, item) {
      if (!item.collections) return;
      $.each(item.collections, function(j, col) {
        var colLower = col.title.toLowerCase();
        var titleMatch = strictMatch
          ? strictWords.every(function(w) { return colLower.indexOf(w) !== -1; })
          : true;
        if (!seen[col.url] && menuByUrl[col.url] && titleMatch) {
          seen[col.url] = true;
          cats.push(col);
        }
      });
    });
    return cats;
  }

  function srClose() {
    $('body').removeClass('showOverly');
    $('#searchPopup').removeClass('active');
    $('form[action="/search"] .sr-box').hide().empty();
    $('form[action="/search"] input[name="q"]').val('').removeAttr('data-old-term');
  }

  var currentReq = null;

  $('form[action="/search"]').css('position', 'relative').each(function() {
    var form = $(this);
    var input = form.find('input[name="q"]');
    if (!form.find('.sr-box').length) {
      $('<div class="sr-box search-results"></div>').appendTo(form).hide();
    }
    input.attr('autocomplete', 'off').on('keyup change input', function() {
      var term = $(this).val();
      var searchURL = '/search?type=product&q=' + encodeURIComponent(term);
      var box = form.find('.sr-box');

      if (term.length === 0) {
        box.hide().empty();
        $(this).removeAttr('data-old-term');
        return;
      }
      if (term.length > 2 && term !== $(this).attr('data-old-term')) {
        $(this).attr('data-old-term', term);
        if (currentReq) currentReq.abort();
        currentReq = $.getJSON(searchURL + '&view=json', function(data) {
          box.empty();
          if (!data.results_count) { box.hide(); return; }

          var html = '';

          if (data.results.length) {
            html += '<div class="sr-section-label">Produkty</div><ul class="sr-products">';
            $.each(data.results, function(i, item) {
              var priceHtml = item.compare_at_price
                ? '<span class="sr-price-stack">' +
                    '<s class="sr-price-compare">' + item.compare_at_price + '</s>' +
                    '<span class="sr-price-sale">' + item.price + '</span>' +
                  '</span>' +
                  '<span class="sr-disc-badge">-' + item.discount_pct + '%</span>'
                : '<span class="sr-price-regular">' + item.price + '</span>';
              html += '<li><a href="' + item.url + '">' +
                '<span class="sr-img"><img src="' + item.thumbnail + '" /></span>' +
                '<span class="sr-details">' +
                  '<span class="sr-title">' + srHighlight(item.title, term) + '</span>' +
                '</span>' +
                '<span class="sr-price">' + priceHtml + '</span>' +
                '</a></li>';
            });
            html += '</ul>';
          }

          var cats = srCatsFromResults(data.results, term);
          if (cats.length) {
            html += '<div class="sr-section-label">Kategorie</div><div class="sr-categories">';
            $.each(cats, function(i, cat) {
              html += '<a href="' + cat.url + '" class="sr-cat-chip">' + cat.title + '</a>';
            });
            html += '</div>';
          }

          html += '<div class="sr-view-all"><a href="' + searchURL + '">Pokaż wszystkie wyniki dla „' + term + '” &rarr;</a></div>';

          box.html(html).fadeIn(200);
        });
      }
    });
  });

  // Szukaj w sticky bottom nav — toggle / smart focus
  $(document).on('click', '#mob-bottom-nav .searchIco', function(e) {
    e.preventDefault();
    if ($('#searchPopup').hasClass('active')) {
      srClose();
      return;
    }
    var mobHd = document.getElementById('mob-header');
    var headerHidden = mobHd && mobHd.classList.contains('mob-scroll-hide');
    if (!headerHidden) {
      // Sytuacja A — header widoczny: fokus na polu w mob-header
      var inp = $('#mob-header input[name="q"]');
      if (inp.length) {
        inp.focus();
        $('html, body').animate({ scrollTop: 0 }, 200, function() { inp.focus(); });
      }
    } else {
      // Sytuacja B — header ukryty: otwórz modal
      $('body').addClass('showOverly');
      $('#searchPopup').addClass('active');
      setTimeout(function() { $('#searchPopup input[name="q"]').focus(); }, 300);
    }
  });

  // Zamknij modal gdy user scrolluje na górę (mob-header staje się widoczny)
  $(window).on('scroll.search', function() {
    if ($('#searchPopup').hasClass('active') && window.pageYOffset <= 80) {
      srClose();
    }
  });

  // Close on overlay/X
  $(document).on('click', '.modalOverly, .closeSearch', function() { srClose(); });

  // Close on click outside search form
  $(document).on('click', function(e) {
    if (!$(e.target).closest('form[action="/search"]').length) {
      $('form[action="/search"] .sr-box').hide().empty();
      $('form[action="/search"] input[name="q"]').removeAttr('data-old-term');
    }
  });

});